import { useTranslation } from 'react-i18next';

import { Container, ErrorState, Header } from '~/components';

export const ErrorBoundary = () => {
  const { t } = useTranslation(['common', 'dashboard']);

  return (
    <>
      <Header.Root>
        <Header.Content title={t('common:sidebar.dashboard')} />
      </Header.Root>

      <Container>
        <ErrorState onRetry={() => window.location.reload()} title={t('dashboard:error.title')} />
      </Container>
    </>
  );
};
